export const AllSpotifyGenres = [
    "Abstract",
    "Acid",
    "Acid House",
    "Acid Jazz",
    "Acid Rock",
    "Acid Techno",
    "Acoustic Country",
    "Acoustic Folk",
    "Acoustic Pop",
    "Acoustic Rock",
    "Adult Standards",
    "African",
    "African Gospel",
    "Afro Adura",
    "Afro House",
    "Afro Soul",
    "Afrobeats",
    "Afropiano",
    "Afropop",
    "Afroswing",
    "Agronejo",
    "Album Rock",
    "Alt Country",
    "Alté",
    "Alternative Dance",
    "Alternative Hip Hop",
    "Alternative Metal",
    "Alternative Pop",
    "Alternative R&B",
    "Alternative Rock",
    "Alt-Pop",
    "Amapiano",
    "Americana",
    "Anatolian Rock",
    "Anime",
    "Anime Rap",
    "Anison",
    "Aor",
    "Appalachian Music",
    "Arabesk",
    "Arabic Rap",
    "Arena Rock",
    "Arrocha",
    "Art Pop",
    "Art Rock",
    "Atmospheric Black Metal",
    "Aussie Drill",
    "Avant-Garde",
    "Avant-Garde Jazz",
    "Axé",
    "Azonto",
    "Bacardi",
    "Bachata",
    "Bachata Pop",
    "Ballad",
    "Baltimore Club",
    "Banda",
    "Baroque Pop",
    "Bass House",
    "Bass Music",
    "Bassline",
    "Beat",
    "Bebop",
    "Bedroom Pop",
    "Bhajan",
    "Bhangra",
    "Bhojiwood",
    "Big Band",
    "Big Beat",
    "Big Room",
    "Bisrock",
    "Black Metal",
    "Blues Rock",
    "Bolero",
    "Bollywood",
    "Bongo Flava",
    "Boogie",
    "Boogie-Woogie",
    "Boom Bap",
    "Bop",
    "Bossa Nova",
    "Bounce",
    "Brass Band",
    "Breakbeat",
    "Breakcore",
    "Breaks",
    "Brega",
    "Brega Funk",
    "Britpop",
    "Broken Beat",
    "Brooklyn Drill",
    "Bubblegum Pop",
    "Budots",
    "Cajun",
    "Calypso",
    "Cantopop",
    "Canzone Napoletana",
    "Ccm",
    "Cedm",
    "Celtic",
    "Celtic Rock",
    "Cha Cha Cha",
    "Chamber Music",
    "Chamber Pop",
    "Champeta",
    "Chanson",
    "Chicago Blues",
    "Chicago House",
    "Chicha",
    "Children'S Music",
    "Chillstep",
    "Chillwave",
    "Chiptune",
    "Choral",
    "Christian",
    "Christian Alternative Rock",
    "Christian Country",
    "Christian Folk",
    "Christian Hip Hop",
    "Christian Pop",
    "Christian Rock",
    "Christmas",
    "City Pop",
    "Classic Blues",
    "Classic Rock",
    "Classical Piano",
    "Cloud Rap",
    "Coldwave",
    "Conscious",
    "Contemporary",
    "Contemporary Jazz",
    "Contemporary R&B",
    "Cool Jazz",
    "Corrido",
    "Corridos Tumbados",
    "Country Blues",
    "Country Hip Hop",
    "Country Rock",
    "C-Pop",
    "Crunk",
    "Crust",
    "Cuarteto",
    "Cubano",
    "Cumbia",
    "Cumbia Norteña",
    "Cumbia Sonidera",
    "Dance",
    "Dance Pop",
    "Dangdut",
    "Dansband",
    "Dansktop",
    "Dark Ambient",
    "Dark Cabaret",
    "Dark Trap",
    "Darkwave",
    "Death Metal",
    "Deathcore",
    "Deathrock",
    "Deathstep",
    "Deep House",
    "Deep Techno",
    "Delta Blues",
    "Dembow",
    "Depressive Black Metal",
    "Disco House",
    "Disco Polo",
    "Dixieland",
    "Djent",
    "Doom Metal",
    "Doo-Wop",
    "Downtempo",
    "Dream Pop",
    "Drift Phonk",
    "Drill",
    "Drone",
    "Drumstep",
    "Dub Techno",
    "Dubstep",
    "Dungeon Synth",
    "Duranguense",
    "East Coast Hip Hop",
    "Easy Listening",
    "Ebm",
    "Edm",
    "Edm Trap",
    "Electric Blues",
    "Electro",
    "Electro Corridos",
    "Electro House",
    "Electro Swing",
    "Electroacoustic",
    "Electroclash",
    "Electronic Rock",
    "Electronica",
    "Electropop",
    "Emo Pop",
    "Emo Rap",
    "Emocore",
    "Enka",
    "Entehno",
    "Epadunk",
    "Ethereal",
    "Ethiopian Jazz",
    "Euro House",
    "Eurobeat",
    "Eurodance",
    "Euro-Disco",
    "Europop",
    "Exotica",
    "Experimental",
    "Experimental Hip Hop",
    "Fado",
    "Flamenco",
    "Folk Metal",
    "Folk Pop",
    "Folk Punk",
    "Folk Rock",
    "Folklore Argentino",
    "Footwork",
    "Forró",
    "Forro Tradicional",
    "Free Improvisation",
    "Free Jazz",
    "Freestyle",
    "Freetekno",
    "French House",
    "Frenchcore",
    "Fújì",
    "Funeral Doom Metal",
    "Funk Carioca",
    "Funk Consciente",
    "Funk De Bh",
    "Funk Melody",
    "Funk Metal",
    "Funk Pop",
    "Funk Rock",
    "Funkot",
    "Funky House",
    "Fusion",
    "Future Bass",
    "Future House",
    "Future Jazz",
    "Gabber",
    "Gamelan",
    "Gangsta",
    "Gangster Rap",
    "Garage House",
    "Garage Rock",
    "Gengetone",
    "G-Funk",
    "Ghazal",
    "G-House",
    "Glam",
    "Glam Metal",
    "Glam Rock",
    "Glitch",
    "Gnawa",
    "Goa Trance",
    "Go-Go",
    "Goregrind",
    "Gospel",
    "Gospel R&B",
    "Goth Rock",
    "Gothic Country",
    "Gothic Metal",
    "Gqom",
    "Gregorian Chant",
    "Grime",
    "Grindcore",
    "Groove Metal",
    "Grupera",
    "Guaracha",
    "Gufeng",
    "Gujarati Garba",
    "Gujarati Pop",
    "Gypsy Jazz",
    "Hands Up",
    "Happy Hardcore",
    "Harana",
    "Hard Bop",
    "Hard House",
    "Hard Rock",
    "Hard Techno",
    "Hard Trance",
    "Hardcore",
    "Hardcore Hip Hop",
    "Hardcore Punk",
    "Hardcore Techno",
    "Hardstyle",
    "Harmonica Blues",
    "Harsh Noise Wall",
    "Haryanvi Pop",
    "Hawaiian",
    "Heavy Metal",
    "Highlife",
    "Hindi Hip Hop",
    "Hindi Indie",
    "Hindi Pop",
    "Hindustani",
    "Hi-Nrg",
    "Hip House",
    "Hiplife",
    "Holiday",
    "Honky Tonk",
    "Horror Rock",
    "Horrorcore",
    "Huayno",
    "Hyperpop",
    "Hypertechno",
    "Hyphy",
    "Idm",
    "Impressionist",
    "Indian Classical",
    "Indian Indie",
    "Indie Dance",
    "Indie Electronic",
    "Indie Folk",
    "Indie Jazz",
    "Indie Pop",
    "Indie Punk",
    "Indie R&B",
    "Indie Rock",
    "Indorock",
    "Industrial Metal",
    "Industrial Rock",
    "Iskelmä",
    "Italo Dance",
    "Italo Disco",
    "Jangle Pop",
    "Japanese Vgm",
    "Jazz Beats",
    "Jazz Blues",
    "Jazz Funk",
    "Jazz Fusion",
    "Jazz House",
    "Jazz Rap",
    "Jazz Rock",
    "Jazzdance",
    "Jazzy Hip-Hop",
    "J-Dance",
    "Jersey Club",
    "J-R&B",
    "J-Rap",
    "J-Rock",
    "Juke",
    "Jump Blues",
    "Jumpstyle",
    "Jungle",
    "Kannada Pop",
    "Karadeniz Folk",
    "Kayokyoku",
    "K-Ballad",
    "Khaleeji",
    "Kizomba",
    "Klezmer",
    "Kollywood",
    "K-Rap",
    "Krautrock",
    "K-Rock",
    "Kuduro",
    "Kundiman",
    "Lagu Jawa",
    "Laïko",
    "Latin Afrobeat",
    "Latin Afrobeats",
    "Latin Alternative",
    "Latin Dance",
    "Latin Folk",
    "Latin Hip Hop",
    "Latin House",
    "Latin Indie",
    "Latin Jazz",
    "Latin Pop",
    "Latin R&B",
    "Latin Rock",
    "Leftfield",
    "Levenslied",
    "Light Music",
    "Liquid Funk",
    "Lo-Fi",
    "Lo-Fi Beats",
    "Lo-Fi House",
    "Lounge",
    "Lovers Rock",
    "Luk Thung",
    "Lullaby",
    "Madchester",
    "Mahraganat",
    "Makina",
    "Maluku",
    "Mambo",
    "Mandopop",
    "Manele",
    "Marathi Pop",
    "Marches",
    "Mariachi",
    "Math Rock",
    "Medieval",
    "Medieval Metal",
    "Melbourne Bounce",
    "Melodic Bass",
    "Melodic Death Metal",
    "Melodic Hardcore",
    "Melodic House",
    "Melodic Metal",
    "Melodic Rap",
    "Melodic Techno",
    "Meme Rap",
    "Merengue",
    "Metalcore",
    "Miami Bass",
    "Midwest Emo",
    "Military",
    "Minimal Techno",
    "Minimalism",
    "Min'Yō",
    "Mizrahi",
    "Mod",
    "Modal",
    "Modern",
    "Modern Blues",
    "Modern Classical",
    "Modern Electric Blues",
    "Modern Rock",
    "Mollywood",
    "Moombahton",
    "Motown",
    "Mpb",
    "Music Hall",
    "Musicals",
    "Musique Concrète",
    "Nederpop",
    "Neo Soul",
    "Neo-classical",
    "Neofolk",
    "Neomelodico",
    "Neoperreo",
    "Neo-Romantic",
    "Népzene",
    "Nerdcore",
    "Neue Deutsche Welle",
    "New Age",
    "New Beat",
    "New Jack Swing",
    "New Rave",
    "New Wave",
    "New York Drill",
    "Newgrass",
    "Nightcore",
    "No Wave",
    "Noise",
    "Noise Rock",
    "Noisecore",
    "Nordic",
    "Norteño",
    "Norteño-Sax",
    "Northern Soul",
    "Nova Mpb",
    "Novelty",
    "Nu Disco",
    "Nu Jazz",
    "Nu Metal",
    "Nueva Trova",
    "Occitan",
    "Oi",
    "Opera",
    "Operetta",
    "Opm",
    "Oratorio",
    "Orchestra",
    "Organ",
    "Organic House",
    "Oyun Havasi",
    "Pacific",
    "Pagode",
    "Pagode Baiano",
    "Pentecostal",
    "Philly Club",
    "Philly Soul",
    "Phleng Phuea Chiwit",
    "Phonk",
    "Piano Blues",
    "Pirate Metal",
    "Piseiro",
    "Polka",
    "Pop Country",
    "Pop Punk",
    "Pop R&B",
    "Pop Rap",
    "Pop Rock",
    "Pop Soul",
    "Pop Urbaine",
    "Pop Worship",
    "Post-Bop",
    "Post-Disco",
    "Post-Grunge",
    "Post-Hardcore",
    "Post-Metal",
    "Post-Modern",
    "Post-Punk",
    "Post-Rock",
    "Power Electronics",
    "Power Metal",
    "Power Pop",
    "Power Violence",
    "P-Pop",
    "Progressive House",
    "Progressive Metal",
    "Progressive Rock",
    "Progressive Trance",
    "Proto-Punk",
    "Psychedelic",
    "Psychedelic Pop",
    "Psychedelic Rock",
    "Psychobilly",
    "Psytrance",
    "Pub Rock",
    "Punk Rap",
    "Punta",
    "Qawwali",
    "Quiet Storm",
    "Rage Rap",
    "Ragga",
    "Ragga Hiphop",
    "Ragtime",
    "Raï",
    "Rally House",
    "Ranchera",
    "Rap Metal",
    "Rap Rock",
    "Red Dirt",
    "Reggae Pop",
    "Reggae Rock",
    "Reggaeton",
    "Religious",
    "Renaissance",
    "Requiem",
    "Retro Soul",
    "Rhumba",
    "Rhythmic Noise",
    "Riddim",
    "Rkt",
    "Rock And Roll",
    "Rock Urbano",
    "Rockabilly",
    "Rocksteady",
    "Romani",
    "Romantic",
    "Roots Reggae",
    "Roots Rock",
    "Rumba",
    "Russelåter",
    "Sad Sierreño",
    "Salsa",
    "Salsa Romantica",
    "Samba",
    "Sandalwood",
    "Schlager",
    "Schlagerparty",
    "Score",
    "Screamo",
    "Screw",
    "Sea Shanties",
    "Seresta",
    "Sertanejo",
    "Sertanejo Tradicional",
    "Sertanejo Universitário",
    "Shatta",
    "Shibuya-Kei",
    "Shoegaze",
    "Sholawat",
    "Sierreño",
    "Singeli",
    "Singer-Songwriter",
    "Ska Punk",
    "Skate Punk",
    "Slap House",
    "Slowcore",
    "Sludge Metal",
    "Smooth Jazz",
    "Smooth R&B",
    "Smooth Soul",
    "Soca",
    "Soft Pop",
    "Soft Rock",
    "Son",
    "Son Cubano",
    "Soukous",
    "Soul Blues",
    "Soul Jazz",
    "Soundtrack",
    "Southern Gospel",
    "Southern Hip Hop",
    "Southern Rock",
    "Space Music",
    "Space Rock",
    "Space-Age",
    "Speed Metal",
    "Speedcore",
    "Stoner Rock",
    "Stutter House",
    "Sufi",
    "Surf Rock",
    "Symphonic Metal",
    "Symphonic Rock",
    "Synthpop",
    "Synthwave",
    "Tango",
    "Tech House",
    "Tech Trance",
    "Technical Death Metal",
    "Tecnobrega",
    "Tejano",
    "Tekno",
    "Theme",
    "Thrash",
    "Thrash Metal",
    "Thug Rap",
    "Timba",
    "Tollywood",
    "T-Pop",
    "Traditional Country",
    "Traditional Music",
    "Trap Funk",
    "Trap Latino",
    "Tribal",
    "Tribal House",
    "Trip Hop",
    "Tropical House",
    "Tropical Music",
    "Trova",
    "Turreo",
    "Uk Drill",
    "Uk Funky",
    "Uk Garage",
    "Underground Hip Hop",
    "Urbano Latino",
    "Vallenato",
    "Vaporwave",
    "Variété Française",
    "Video Game Music",
    "Viking Metal",
    "Vinahouse",
    "Visual Kei",
    "Vocal",
    "Vocal Jazz",
    "Vocaloid",
    "Volksmusik",
    "V-Pop",
    "West Coast Hip Hop",
    "Witch House",
    "Worship",
    "Zouk",
    "Zydeco"
]